module.exports = __webpack_public_path__ + "static/media/top_infographic_mobile.48784af5.webp";